// extracted by mini-css-extract-plugin
module.exports = {"box":"InsuredInfo_box__3XV1j"};